{
	"page": {
		"title": "Events",
		"intro": "The medal events of each games, under their sport and discipline. An event's <strong>result settings</strong> are the defaults its meets inherit; they freeze once a meet holds results, and most settings freeze while the event is <strong>locked</strong> after its medals.",
		"addEvent": "Add event",
		"building": "This page is being built.",
		"count_one": "{{n}} event",
		"count_other": "{{n}} events"
	},
	"filters": {
		"gamesLabel": "Games",
		"sportLabel": "Sport",
		"disciplineLabel": "Discipline",
		"pickSportFirst": "Pick a sport first",
		"genderLabel": "Gender",
		"competitorTypeLabel": "Individual / team",
		"searchPlaceholder": "Search events by code or name",
		"searchSports": "Search sports",
		"searchDisciplines": "Search disciplines"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"sport": "Sport",
		"discipline": "Discipline",
		"gender": "Gender",
		"competitorType": "Type",
		"teamSize": "Team size",
		"teamSizeRange": "{{min}}–{{max}}",
		"teamSizeAtLeast": "{{min}} or more",
		"teamSizeAtMost": "Up to {{max}}",
		"resultFamily": "Result family",
		"resultType": "Result type",
		"direction": "Ranking",
		"medals": "Medals",
		"medalsValue": "{{gold}} / {{silver}} / {{bronze}}",
		"medalsTitle": "Gold / silver / bronze the event is expected to award",
		"notMedalEvent": "No medals",
		"ceremony": "Ceremony",
		"maxEntries": "Entries per NOC",
		"noLimit": "No limit",
		"sportClasses": "Para classes",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"locked": "Locked",
		"lockedTitle": "Medals awarded — results and most settings are frozen until it is unlocked",
		"lockedAt": "Locked {{at}}. Medals awarded — results and most settings are frozen until it is unlocked.",
		"phases": "Phases",
		"meets": "Meets",
		"competitors": "Competitors",
		"competitorsTitle": "Entries in this event",
		"sortOrder": "Order",
		"created": "Created",
		"updated": "Updated",
		"viewLabel": "View {{name}}",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"quotas": "Entries / Shortlist",
		"quotasTitle": "Entries that compete per NOC / Primary athletes a NOC may shortlist. A dash: not set (the shortlist then follows the entry quota).",
		"quotasValue": "{{entries}} / {{shortlist}}",
		"standard": "Standard",
		"standardLower": "Qualifies at or under this mark (lower is better)",
		"standardHigher": "Qualifies at or over this mark (higher is better)"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} event",
		"summary_other": "{{from}}–{{to}} of {{total}} events",
		"empty": "No events"
	},
	"empty": {
		"filteredTitle": "No events match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No events in this games yet",
		"noneDescription": "Add the medal events of each discipline.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add event",
		"addDescription": "A new event under a discipline. Its result settings become the defaults of every meet it holds.",
		"addSubmit": "Add event",
		"editTitle": "Edit event",
		"saveChanges": "Save changes",
		"editLocked": "This event is locked: until it is unlocked, only its name, translations, order and ceremony time can change.",
		"editInUse_one": "{{count}} competitor is entered — individual / team can no longer change.",
		"editInUse_other": "{{count}} competitors are entered — individual / team can no longer change.",
		"editEmpty": "No competitors are entered yet.",
		"resultsFrozenHint": "Frozen once a meet that inherits it holds results.",
		"section": {
			"placement": "Placement",
			"placementHint": "The sport and discipline this event belongs to. It cannot move once created.",
			"identity": "Identity",
			"identityHint": "How the event reads on schedules, start lists and results.",
			"translations": "Translations",
			"translationsHint": "The name in each GMS language. Leave a box empty to show the English name.",
			"entry": "Entry",
			"entryHint": "Who may enter, and what one entry is.",
			"results": "Results",
			"resultsHint": "Defaults for this event's meets — a meet may override them.",
			"medals": "Medals",
			"medalsHint": "What the event is expected to award — a check for the medal desk, never a medal.",
			"sportClasses": "Para classes",
			"sportClassesHint": "The classes of this sport the event is open to.",
			"display": "Display",
			"displayHint": "Where the event sits in lists, and whether pickers offer it.",
			"standard": "Qualifying standard",
			"standardHint": "The mark a Primary athlete's best record must meet when a NOC shortlists. Reserves need none."
		},
		"field": {
			"sport": "Sport",
			"discipline": "Discipline",
			"name": "Name",
			"nameHint": "The English name — the master every translation follows.",
			"code": "Code",
			"codeHint": "Letters, numbers, - and _ only, like M100FR. Stored in capitals.",
			"gender": "Gender",
			"competitorType": "Individual / team",
			"teamSizeMin": "Smallest team",
			"teamSizeMax": "Largest team",
			"teamSizeHint": "Athletes on one roster. Leave empty for no bound.",
			"resultFamily": "Result family",
			"resultFamilyHint": "Decides the scoring screen and what a result records.",
			"resultType": "Result type",
			"resultTypeHint": "What the headline number measures.",
			"lowerIsBetter": "Lower is better",
			"lowerIsBetterHint": "On for times; off for points, distances and weights.",
			"isMedalEvent": "Medal event",
			"isMedalEventHint": "Off for exhibition and qualification-only events.",
			"goldCount": "Gold",
			"silverCount": "Silver",
			"bronzeCount": "Bronze",
			"medalCountHint": "Two bronzes in most combat sports.",
			"ceremony": "Medal ceremony",
			"ceremonyHint": "In your own time zone. Leave empty if not scheduled yet.",
			"maxEntries": "Entries per NOC",
			"maxEntriesHint": "Entries that compete per NOC. Leave empty for no limit.",
			"sportClasses": "Para classes",
			"sportClassesPlaceholder": "Open to every class",
			"sortOrder": "Sort order",
			"sortOrderHint": "Lists order by this, within the discipline.",
			"isActive": "Active",
			"isActiveHint": "An inactive event stays on record but leaves the pickers and OVR's navigation.",
			"maxShortlist": "Shortlist quota per NOC",
			"maxShortlistHint": "Primary athletes a NOC may shortlist. Leave empty to use the entry quota.",
			"qualifyingMark": "Qualifying standard",
			"qualifyingMarkHint": {
				"TIME": "A time, like 1:58.50 or 10.75. Leave empty for none.",
				"DISTANCE": "Metres, like 7.20. Leave empty for none.",
				"WEIGHT": "Kilograms, like 250. Leave empty for none.",
				"POINTS": "Points, like 8123. Leave empty for none.",
				"SCORE": "A score, like 13.533. Leave empty for none."
			},
			"qualifyingMarkNone": "This result measures nothing, so the event takes no standard.",
			"qualifyingMarkPick": "Pick a result type first.",
			"qualifyingMarkReadsLower": "Reads as {{mark}}. A best record at or under it qualifies.",
			"qualifyingMarkReadsHigher": "Reads as {{mark}}. A best record at or over it qualifies.",
			"qualifyingNote": "Qualifying note",
			"qualifyingNoteHint": "Shown with the standard."
		},
		"placeholder": {
			"sport": "Pick a sport",
			"discipline": "Pick a discipline",
			"name": "Men's 100m Freestyle",
			"code": "M100FR",
			"gender": "Pick who may enter",
			"competitorType": "Pick individual or team",
			"resultFamily": "Pick a result family",
			"resultType": "Pick a result type",
			"qualifyingMark": {
				"TIME": "1:58.50",
				"DISTANCE": "7.20",
				"WEIGHT": "250",
				"POINTS": "8123",
				"SCORE": "13.533"
			},
			"qualifyingNote": "Achieved since 1 Jan 2026 at a sanctioned meet"
		},
		"quotaHelp": "Entries are the places a NOC fills in competition (the Entry by Number and medal cap). The shortlist is the wider pool of Primary athletes it may name for them. Badminton singles, for example: 2 entries, 4 shortlisted."
	},
	"delete": {
		"title": "Delete event",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing hangs off it — phases, meets or competitors. To take it off the programme, mark it inactive instead.",
		"confirm": "Delete event",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete event",
		"locked": "This event is locked by the medal desk. Unlock it before deleting it."
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add event",
		"updateFailed": "Couldn't update event"
	},
	"errors": {
		"codeTaken": "An event with that code already exists in this discipline.",
		"nameTaken": "An event with that name already exists for this gender in this discipline.",
		"disciplineMissing": "That discipline no longer exists.",
		"locked": "This event is locked. Unlock it before changing anything but its name, translations, order or ceremony time.",
		"competitorTypeInUse": "The event has competitors, so individual / team can no longer change.",
		"resultSettingInUse": "A meet that inherits this setting already holds results, so it can no longer change.",
		"sportClassesRefused": "Every class must belong to this event's sport, and a class a competitor competes in cannot be removed.",
		"sportClassesInUse_one": "{{codes}} cannot be removed: a competitor of this event competes in that class.",
		"sportClassesInUse_other": "{{codes}} cannot be removed: competitors of this event compete in those classes.",
		"teamSizeRefused": "These team sizes don't fit the event as stored.",
		"inUse": "This event still has phases, meets or competitors. Remove those first, or mark it inactive.",
		"invalidValue": "Invalid value",
		"shortlistBelowEntries": "For an individual event the shortlist quota cannot be below the entry quota.",
		"qualifyingMarkRefused": "An event whose result measures nothing takes no qualifying standard."
	},
	"gender": {
		"MEN": "Men",
		"WOMEN": "Women",
		"MIXED": "Mixed",
		"OPEN": "Open"
	},
	"competitorType": {
		"INDIVIDUAL": "Individual",
		"TEAM": "Team"
	},
	"resultFamily": {
		"TIMED": "Timed",
		"ATTEMPTS": "Attempts",
		"SETS": "Sets and periods",
		"BOUT": "Bout",
		"JUDGED": "Judged",
		"ROUNDS": "Rounds",
		"LIFTS": "Lifts",
		"GENERIC": "Generic"
	},
	"resultFamilyHint": {
		"TIMED": "Swimming, track, cycling, rowing — splits and reaction times",
		"ATTEMPTS": "Jumps and throws — attempts with mark, wind, valid or foul",
		"SETS": "Racket, net and period sports — scores per set or period",
		"BOUT": "Combat sports — rounds, penalties, judges' cards",
		"JUDGED": "Gymnastics, diving, taolu — component scores",
		"ROUNDS": "Golf, bowling, sailing, shooting — per-round values",
		"LIFTS": "Weightlifting, powerlifting — attempts with good or no lift",
		"GENERIC": "Anything not modelled yet"
	},
	"resultType": {
		"TIME": "Time",
		"DISTANCE": "Distance",
		"POINTS": "Points",
		"SCORE": "Score",
		"WEIGHT": "Weight",
		"NONE": "None — outcome only"
	},
	"direction": {
		"lower": "Lower is better",
		"higher": "Higher is better"
	},
	"sort": {
		"event": "Gender, then event",
		"programme": "Programme order",
		"programmeDesc": "Programme order, reversed",
		"genderAsc": "Gender A–Z",
		"genderDesc": "Gender Z–A",
		"orderAsc": "Order number, low to high",
		"orderDesc": "Order number, high to low"
	},
	"stats": {
		"total": "Events",
		"matching": "matching the filters",
		"individual": "Individual events",
		"team": "Team events"
	},
	"mark": {
		"TIME": "{{mark}}",
		"DISTANCE": "{{mark}} m",
		"WEIGHT": "{{mark}} kg",
		"POINTS": "{{mark}} pts",
		"SCORE": "{{mark}}"
	}
}
